import { DateRangePicker, DateRangePickerProps } from '@blueprintjs/datetime'
import { DateRange } from '@blueprintjs/datetime/src/common/dateRange'
import { Popover } from '../../../components/ui/popover'
import { format } from 'date-fns'
import React, { ReactNode, useState } from 'react'
import { CalendarIcon } from '../../../icons/icons'
import { Button } from '../../../components/ui/button'

const DATE_FORMAT_LONG = 'MMM d, yyyy'
const DATE_FORMAT_SHORT = 'MMM d'

const formatDateRange = (from: Date, to: Date): string => {
    return formatDate(from) + ' - ' + formatDate(to)
}

const formatDate = (date: Date): string => {
    if (new Date().getFullYear() == date.getFullYear()) {
        return format(date, DATE_FORMAT_SHORT)
    } else {
        return format(date, DATE_FORMAT_LONG)
    }
}

interface DateRangeSelectProps extends DateRangePickerProps {
    value: DateRange
    onChange: (selectedDates: DateRange) => void
    after?: ReactNode

    /**
     * Function to render a JavaScript `Date` to a string.
     * Optional `locale` argument comes directly from the prop on this component:
     * if the prop is defined, then the argument will be too.
     */
    formatDate?: (date: Date, locale?: string) => string
    /**
     * Function to deserialize user input text to a JavaScript `Date` object.
     * Return `false` if the string is an invalid date.
     * Return `null` to represent the absence of a date.
     * Optional `locale` argument comes directly from the prop on this component.
     */
    parseDate?: (str: string, locale?: string) => Date | false | null
}

export const DateRangeSelect = (props: DateRangeSelectProps) => {
    const [open, setOpen] = useState(false)

    const picker = (
        <div>
            <DateRangePicker
                {...props}
                onChange={(value) => {
                    if (value[0] && value[1]) {
                        setOpen(false)
                    }
                    props.onChange(value)
                }}
            />
            {props.after}
        </div>
    )

    let range = ''
    if (props.value[0] && props.value[1]) {
        range = formatDateRange(props.value[0], props.value[1])
    }

    return (
        <Popover content={picker} isOpen={open} onClose={() => setOpen(false)}>
            <Button
                minimal
                outlined
                className="rounded-lg"
                icon={<CalendarIcon />}
                text={<span className="whitespace-nowrap">{range}</span>}
                onClick={() => setOpen(true)}
            />
        </Popover>
    )
}
